let googleMapsKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
let apiUrl = process.env.VUE_APP_API_URL;
let systemName = process.env.VUE_APP_SYSTEM_NAME;
let recapchaSiteKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
let originLat = process.env.VUE_APP_ORIGIN_LAT;
let originLng = process.env.VUE_APP_ORIGIN_LNG;
let reverbAppKey = process.env.VUE_APP_REVERB_APP_KEY;
let reverbHost = process.env.VUE_APP_REVERB_HOST;
let reverbPath = process.env.VUE_APP_REVERB_PATH;
let reverbPort = process.env.VUE_APP_REVERB_PORT;
let reverbScheme = process.env.VUE_APP_REVERB_SCHEME;

export const Keys = {
  GOOGLE_MAPS_API_KEY: googleMapsKey,
  VUE_APP_API_URL: apiUrl,
  VUE_APP_SYSTEM_NAME: systemName,
  VUE_APP_RECAPTCHA_SITE_KEY: recapchaSiteKey,
  VUE_APP_ORIGIN_LAT: originLat,
  VUE_APP_ORIGIN_LNG: originLng,
  VUE_APP_REVERB_APP_KEY: reverbAppKey,
  VUE_APP_REVERB_HOST: reverbHost,
  VUE_APP_REVERB_PATH: reverbPath,
  VUE_APP_REVERB_PORT: reverbPort,
  VUE_APP_REVERB_SCHEME: reverbScheme,
};
